"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSiteSection_1 = require("./getSiteSection");
var utils_1 = require("../utils");
// Getting Site Section Level2 with browser default props
function setSiteSectionLevel2() {
    var locationPathname = (0, utils_1.removeSpecialCharacters)(window.location.pathname);
    var siteSection = (0, getSiteSection_1.default)();
    if (siteSection === "home" || locationPathname.split("/")[2] === undefined) {
        return "";
    }
    else {
        return locationPathname.split("/")[2].replace(".", "-").toLowerCase();
    }
}
exports.default = setSiteSectionLevel2;
